import { useEffect, useState } from "react";
import {
  cookies,
  instance,
  NotificationUrl,
} from "../Controller/Common";
import { useDispatch, useSelector } from "react-redux";
import {
  GetNewNotifications,
  GetNotifications,
  GetNotificationsLength,
} from "../Redux/NotificationsSlice";
import { RootState } from "../Redux/UserSlice";

const AppNotification = () => {
  const userId = cookies.get("userId");
  const StoresuserId = useSelector((state: RootState) => state.user.userID);
  const activeUserId = StoresuserId || userId;

  const [error, setError] = useState<string | null>(null);
  const dispatch = useDispatch();
  const notifications = useSelector(
    (state: any) => state.notifications.notifications
  );

  useEffect(() => {
    if (!activeUserId) return;

    const eventSource = new EventSource(NotificationUrl(activeUserId));
    eventSource.onopen = () => {
      console.log("EventSource connection opened.");
    };

    eventSource.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data.type === "existingNotifications") {
        dispatch(GetNewNotifications(data.data));
        dispatch(GetNotificationsLength(data.count));
      } else if (data.type === "newNotification") {
        dispatch(GetNewNotifications(data.data));
        dispatch(GetNotificationsLength(data.count));
      } else if (data.type === "markAsRead") {
        dispatch(GetNewNotifications(data.data));
        dispatch(GetNotificationsLength(data.count));
      }
    };

    eventSource.onerror = (error) => {
      console.error("SSE error:", error);
      setError("Failed to connect to notifications.");
      eventSource.close();
    };

    return () => {
      eventSource.close();
    };
  }, [activeUserId, dispatch]);
  
  const fetchNotifications = async () => {
    if (!activeUserId) return;
    try {
      const response = await instance.get(
        `/6D/notifications/fetchAllNotifications/${activeUserId}`
      );
      const data = response.data;
      if (response.status === 200) {
        dispatch(GetNotifications(data.data));
        dispatch(GetNotificationsLength(data.count));
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
      setError("Failed to fetch notifications.");
    }
  };

  const handleMarkAllAsRead = async () => {
    try {
      const response = await instance.post(
        `/6D/notifications/markAllAsRead/${activeUserId}`
      );
      if (response.status === 200) {
        const updatedNotifications = notifications.map((notification: any) => ({
          ...notification,
          Read: "Y",
        }));
        dispatch(GetNotifications(updatedNotifications));
      }
    } catch (error) {
      console.error(error);
    }
  };
  const markAsRead = async (id: number) => {
    try {
      const response = await instance.post(
        `/6D/notifications/markAsRead/${id}/${activeUserId}`
      );
      if (response.status === 200) {
        const updatedNotifications = notifications.map((notification: any) =>
          notification.ID === id ? { ...notification, Read: "Y" } : notification
        );
        dispatch(GetNotifications(updatedNotifications));
      }
    } catch (error) {
      console.error(error);
    }
  };

  return {
    notifications,
    fetchNotifications,
    markAsRead,
    handleMarkAllAsRead,
  };
};

export { AppNotification };
